import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const setUnReadFn = (data) => apiClient.delete(`${APP_API_URL}action-list/set-unread`, { data });

export const useSetUnReadMutation = () => {
  return useMutation({
    mutationFn: setUnReadFn,
  });
};
